import ButtonAdd from 'components/Global/ButtonAdd';
import Tabs, { TabPane } from 'components/Global/Tabs';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Influencers from './influencers';
import CommonUsers from './common-user';

const TestimonialPage = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();

  const tabActive = searchParams.get('tab-active');

  const handleAdd = () => {
    navigate('/testimonial/add');
  };

  useEffect(() => {
    if (!tabActive) {
      setSearchParams({ 'tab-active': 'Influencers' });
    } else {
      setActiveTab(tabActive);
    }
  }, [tabActive]);

  return (
    <div className="testimonial">
      <ButtonAdd onClick={handleAdd} label="Tambah Testimonial" />

      <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
        <TabPane label="Influencers">
          <Influencers />
        </TabPane>
        <TabPane label="Common Users">
          <CommonUsers />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default TestimonialPage;
